// removed by extract-text-webpack-plugin
module.exports = {"base":"Suitability_base--2htgN","levels":"Suitability_levels--3Q6ek","titleContainer":"Suitability_titleContainer--1I9Pd","strongholdLevel":"Suitability_strongholdLevel--wqPnP","level":"Suitability_level--iWKOe","level__active":"Suitability_level__active--1Q3r3","levelActive":"Suitability_level__active--1Q3r3"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Suitability/Suitability.scss
// module id = 2257
// module chunks = 11